module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/woman_holding_phone-52317dfda9b19017ac1c59c267dc66d2.png";